import {connect} from '../../../app/connect';
import IssuesPermissionsAdmin from './IssuesPermissionsAdmin';

import {getIssuesPermissionsFetchError, isUpdatingPermissions} from '../../../app/selectors';
import {fetchIssuesPermissions, showNotificationAction, trackEvent} from '../../../app/actions';

const mapStateToProps = state => ({
  fetchError: !!getIssuesPermissionsFetchError(state),
  isUpdatingPermissions: isUpdatingPermissions(state)
});

const mapDispatchToProps = {
  fetchIssuesPermissions,
  showNotificationAction,
  trackEvent
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssuesPermissionsAdmin);
